import classNames from "classnames"
import { useTranslation } from "react-i18next"
import { CrossLight, Timer } from "assets/icons"
import "./index.css"
import { useLanguageContext } from "store/LanguageProvider"

export const ChatInstructions = ({ chatStarted, question, handleStartChat, totalTime, multiChatQuiz = false }) => {
    const { direction, rtlView } = useLanguageContext()
    const { t } = useTranslation()

    return (
        <div dir={direction} className={classNames(
            "h-fit chat-instructions max-h-full flex-1 overflow-auto sm:block sm:px-8 sm:py-9",
            {
                "flex-[0.4] hidden": chatStarted,
                "border-r-[1px] border-r-stone-300": chatStarted && !rtlView,
                "border-l-[1px] border-l-stone-300": chatStarted && rtlView,
            }
        )}>
            <p className="text-black text-sm opacity-50 uppercase mb-2 sm:mb-5">{t("chat.heading_instructions")} :</p>
            <div dangerouslySetInnerHTML={{ __html: question }}></div>
            {
                !chatStarted ?
                    <div className="flex flex-col items-center">
                        <div className="flex flex-col sm:flex-row justify-center items-center mt-10 sm:mt-20">
                            <Timer />
                            <p className="text-sm text-center sm:text-left font-semibold text-[#A07DD4] ml-2 mt-2 sm:mt-0">
                                {t("chat.chat_time_instructions", { time: new Date(totalTime * 1000).toISOString().substr(14, 5) })}
                            </p>
                        </div>
                        <button onClick={handleStartChat} className={classNames("rounded-full px-8 py-4 sm:py-2 bg-[#FF7A1A] text-white capitalize text-lg font-semibold mt-4 w-[55vw] sm:w-fit", {
                            "sm:hidden": true
                        })}>
                            {multiChatQuiz ? t("chat.start_session") : t("chat.start_chat")}
                        </button>
                    </div>
                    : <></>
            }
        </div>
    )
}

export const MobileChatInstructions = ({ mobileInstructionsVisible, closeMobileInstructions, question }) => {
    const { direction } = useLanguageContext()
    const { t } = useTranslation()

    return mobileInstructionsVisible ? (
        <div dir={direction} className="bg-mb-instructions chat-instructions absolute flex flex-col items-center justify-end top-0 left-0 w-[100vw] h-[100vh] z-[20] px-3 bg-black/[0.6]">
            <span className="mb-5" role="button" onClick={closeMobileInstructions}>
                <CrossLight />
            </span>
            <div className="bg-white px-4 py-10 rounded-t-[20px] max-h-[70vh] overflow-y-auto">
                <p className="text-black text-sm opacity-50 uppercase mb-2 sm:mb-5">{t("chat.heading_instructions")} :</p>
                <div dangerouslySetInnerHTML={{ __html: question }}></div>
            </div>
        </div>
    ) : <></>
}

